import React, {
  useState,
  useRef,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from 'react';
import { SectionChart } from '@components';
import OrgGrid from './OrgGrid';
import GanttGrid from './GanttGrid';
import SpiderGrid from './SpiderGrid';
import WaterfallGrid from './WaterfallGrid';
import StackedBarGrid from './StackedBarGrid';

// import '@style/components/sectionWidget.scss';

import '../../styles/components/sectionWidget.scss';

const WIDGET_GRID_MAP = {
  gantt: GanttGrid,
  org: OrgGrid,
  spider: SpiderGrid,
  waterfall: WaterfallGrid,
  stackedBar: StackedBarGrid,
};

export default function SectionWidget(props) {
  const {
    data,
    chartType,
    handleSave,
    defaultShowGrid = true,
    showEmptyChart = false,
    controlledEditStatus = false,
  } = props;
  const [isEditMode, setIsEditMode] = useState(false);
  const [showGrid, setGridShow] = useState(defaultShowGrid);
  const dataAvailable =
    Array.isArray(data) &&
    ((chartType !== 'spider' && data.length > 0) ||
      //INFO: spider chart has titles as a row
      (chartType === 'spider' && data.length > 1));
  const shouldShowChart = (dataAvailable || showEmptyChart) && !isEditMode;

  useEffect(() => {
    if (chartType === 'spider') {
      setGridShow(true);
      return;
    }

    if (dataAvailable) {
      setGridShow(false);
    }
  }, [data, chartType]);

  const isHorizontalLayout =
    chartType === 'spider' && showGrid && shouldShowChart;

  const hideShowTableBtn = chartType === 'spider';

  const SectionGrid = WIDGET_GRID_MAP[chartType] || (() => null);

  const editTableRef = useRef(null);

  useEffect(() => {
    if (controlledEditStatus) {
      setGridShow(true);
    }
  }, [controlledEditStatus]);

  return (
    <div className={`widget-wrapper ${isHorizontalLayout ? 'horizontal' : ''}`}>
      {shouldShowChart ? (
        <SectionChart
          inputData={data}
          chartPattern={chartType}
          showInHorizontal={isHorizontalLayout}
          shouldShowChart={shouldShowChart}
          showGrid={showGrid}
          setGridShow={setGridShow}
          hasChartTitle={false}
          hideShowTableBtn={hideShowTableBtn}
        />
      ) : null}
      {showGrid ? (
        <SectionGrid
          editTableRef={editTableRef}
          sourceData={data}
          handleSave={handleSave}
          toggleEdit={setIsEditMode}
          isEditMode={isEditMode}
          {...props}
        />
      ) : null}
    </div>
  );
}
